import React, { useState } from "react";
import { Checkbox } from "antd";
import MultiSelectCm from "../MultiSelectCm/MultiSelectCm";
import { Select } from "antd";
import Styles from "./ExpertRecordsStyles.module.css";
import ReusableMultiSelect from "../../NewComponent/ReusableMultiSelect";

const filterStatusOptions = [
  { name: "open", value: "Open", label: "Open" },
  { name: "rejected", value: "Rejected", label: "Rejected" },
  { name: "answered", value: "Answered", label: "Answered" },
];
const filterRatingOptions = [
  { name: "5", value: "5 Stars", label: "5 Stars" },
  { name: "4", value: "4 Stars", label: "4 Stars" },
  { name: "3", value: "3 Stars", label: "3 Stars" },
  { name: "2", value: "2 Stars", label: "2 Stars" },
  { name: "1", value: "1 Stars", label: "1 Stars" },
  { name: "unrated", value: "Non-rated", label: "Non-rated" },
];
const filterCurationStatusOptions = [
  { name: "curated", value: "Curated", label: "Curated" },
  { name: "pending", value: "Pending", label: "Pending" },
];
const filterCurationCategoryOptions = [
  { name: "1", value: "High", label: "High" },
  { name: "2", value: "Medium", label: "Medium" },
  { name: "3", value: "Low", label: "Low" },
];
export default function QuestionsFilter({ state, onChangeFunc }) {
  const onChangeStatus = (obj1) => {
    const obj2 = {
      name: obj1.value?.toLowerCase() || obj1.key?.toLowerCase(),
      value: obj1.value,
      label: obj1.label,
    };
    onChangeFunc(obj2, "status");
  };
  const onChangeRating = (val) => {
    const obj2 = {
      name: val.value?.toLowerCase() || val.key?.toLowerCase(),
      value: val.value,
      label: val.label,
    };

    const cleanedObj = Object.fromEntries(
      Object.entries(obj2).map(([key, val]) => [
        key,
        val.replace(/stars/i, "").trim(),
      ]),
    );

    if (val.value === "Non-rated") {
      onChangeFunc(
        {
          name: "unrated",
          value: "unrated",
          label: "unrated",
        },
        "rating",
      );
    } else onChangeFunc(cleanedObj, "rating");
  };
  const onChangeCc = (val) => {
    let data = filterCurationCategoryOptions.filter((option) => {
      return val.includes(option.value);
    });
    onChangeFunc(data, "cc");
  };
  const onChangeCs = (val) => {
    let data = filterCurationStatusOptions.filter((option) => {
      return val.includes(option.value);
    });
    onChangeFunc(data, "cs");
  };
  return (
    <>
      <div style={{ textAlign: "start", width: "100%" }}>
        <div
          style={{ display: "flex", alignItems: "baseline", flexWrap: "wrap" }}
        >
          <span style={{ width: "40%", marginRight: "15px", textAlign: "end" }}>
            <span
              style={{
                fontSize: "14px",
                color: "#2A364A",
                fontWeight: "300",
              }}
            >
              Status&nbsp;
            </span>
          </span>
          <span className="py-1" style={{ marginTop: "7px", width: "150px" }}>
            {/* <MultiSelectCm onChangeFunc={onChangeStatus} options={filterStatusOptions} value={state.status} isMulti={false} disabled={false} /> */}
            <Select
              labelInValue
              options={filterStatusOptions}
              value={state.status}
              // defaultValue={{ label: 'All', value: null }}
              onChange={onChangeStatus}
              placeholder="Select Status"
              popupClassName={Styles.searchSuggestionCss}
              showSearch
              filterOption={(input, option) =>
                (option?.label ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              size="middle"
              style={{
                width: "100%",
                border: "none",
                boxShadow: "0px 1px 2px 0px #1018280D",
                fontSize: "16px",
              }}
            />
          </span>
        </div>
        <div
          style={{ display: "flex", alignItems: "baseline", flexWrap: "wrap" }}
        >
          <div style={{ width: "40%", marginRight: "15px", textAlign: "end" }}>
            <span
              style={{
                fontSize: "14px",
                color: "#2A364A",
                fontWeight: "300",
              }}
            >
              Rating&nbsp;
            </span>
          </div>
          <div className="py-1" style={{ marginTop: "7px", width: "150px" }}>
            {/* <MultiSelectCm onChangeFunc={onChangeRating} options={filterRatingOptions} value={state.rating} isMulti={false} disabled={false} /> */}

            <Select
              labelInValue
              options={filterRatingOptions}
              value={state.rating}
              // defaultValue={{ label: 'All', value: null }}
              onChange={onChangeRating}
              placeholder="Select Rating"
              popupClassName={Styles.searchSuggestionCss}
              size="middle"
              showSearch
              filterOption={(input, option) =>
                (option?.label ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              style={{
                width: "100%",
                border: "none",
                boxShadow: "0px 1px 2px 0px #1018280D",
                fontSize: "16px",
              }}
            />
          </div>
        </div>
        <div
          style={{ display: "flex", alignItems: "baseline", flexWrap: "wrap" }}
        >
          <div style={{ width: "40%", marginRight: "15px", textAlign: "end" }}>
            <span
              style={{
                fontSize: "14px",
                color: "#2A364A",
                fontWeight: "300",
              }}
            >
              Expired &nbsp;
            </span>
          </div>
          <div className="py-1" style={{ marginTop: "0px" }}>
            <Checkbox
              checked={state.spill}
              onChange={(e) => onChangeFunc(e.target.checked, "spill")}
            />
          </div>
        </div>
        <div
          style={{ display: "flex", alignItems: "baseline", flexWrap: "wrap" }}
        >
          <div style={{ width: "40%", marginRight: "15px", textAlign: "end" }}>
            <span
              style={{
                fontSize: "14px",
                color: "#2A364A",
                fontWeight: "300",
              }}
            >
              Curation Category&nbsp;
            </span>
          </div>
          <div className="py-1" style={{ marginTop: "7px", width: "150px" }}>
            {/* <MultiSelectCm onChangeFunc={onChangeCc} options={filterCurationCategoryOptions} value={state.cc} isMulti={true} disabled={false} /> */}
            <ReusableMultiSelect
              value={state.cc}
              onChange={onChangeCc}
              options={filterCurationCategoryOptions}
              placeholder="Select categories"
              maxTagPlaceholder={`${state.cc?.length || 0} selected`}
              allowClear={true}
              disabled={false}
              width="100%"
            />
          </div>
        </div>
        <div
          style={{ display: "flex", alignItems: "baseline", flexWrap: "wrap" }}
        >
          <div style={{ width: "40%", marginRight: "15px", textAlign: "end" }}>
            <span
              style={{
                fontSize: "14px",
                color: "#2A364A",
                fontWeight: "300",
              }}
            >
              Curation Status&nbsp;
            </span>
          </div>
          <div className="py-1" style={{ marginTop: "7px", width: "150px" }}>
            {/* <MultiSelectCm onChangeFunc={onChangeCs} options={filterCurationStatusOptions} value={state.cs} isMulti={true} disabled={false} /> */}
            <ReusableMultiSelect
              value={state.cs}
              width="100%"
              onChange={onChangeCs}
              options={filterCurationStatusOptions}
              placeholder="Select status"
              maxTagPlaceholder={`${state.cs?.length || 0} selected`}
              allowClear={true}
              disabled={false}
            />
          </div>
        </div>
      </div>
    </>
  );
}
